<template lang="pug">
  #MsgManagerIndex
    .content-header.bg-secondary.rounded-bottom-1rem
      h5.mb-0 訊息管理
    .container-width
      .p-3
        .mb-3.row
          .col-12.d-flex.mb-2
            .col.px-0.d-flex.align-items-center
              b-form-input.border-0(
                v-model="searchInput.message",
                style="border-radius: 20px;background-color: #eee;",
                placeholder="搜尋訊息"
              )
            .col-auto.pl-2.pr-0
              button.btn.btn-block.btn-remind.font-weight-bold.btn-custom.px-3(
                type="button",
                @click="searchInputHandler",
                style="border: 0.4rem solid #fff;border-radius: 50px;padding: 5px;border: 4px solid #000;box-shadow: 0.2rem 0.2rem 0 #00000033;"
                ) 搜尋
          .col-12.d-flex
            .col-auto.pl-2.pr-0(v-for="status in searchStatusList", :key="status.name")
              button.btn.btn-block.btn-remind.font-weight-bold.btn-custom.px-3(
                type="button",
                @click="searchStatusHandler(status.name)",
                style="border: 0.4rem solid #fff;border-radius: 50px;padding: 5px;border: 4px solid #000;box-shadow: 0.2rem 0.2rem 0 #00000033;"
                ) {{ status.label }}
        b-card.mb-2.customerCard.word-break-all.position-relative(
          bg-variant="white",
          v-for="(user,index) in msgList",
          :key="user.id",
          @click="openMsgHandler(user)",
          body-class="p-0",
          :class="{ 'card-hasNews': user.is_read === 0, 'message-remind': user.is_read === 0}"
        )
          .px-3.pt-3
            .row.align-items-center.no-gutters
              .col-3.pr-2
                ProfilePhotoSticker.ProfilePhotoSticker.d-flex.align-items-center.justify-content-center.border.border-black(
                  :profileUrl="user.picture_url",
                  :style="{ 'width': '60px', 'height': '60px' }"
                )
              .col-9.pl-2.font-weight-bold
                .d-flex
                  div
                    p.mb-0 Line 暱稱：
                  div(
                    style="flex: 1;"
                  )
                    p.mb-0 {{ user.display_name }}
                .d-flex
                  div
                    p.mb-0 備註名：
                  div(
                    style="flex: 1;"
                  )
                    p.mb-0 {{ user.note_name }}
                .d-flex
                  div
                    p.mb-0 MARSID：
                  div(
                    style="flex: 1;"
                  )
                    p.mb-0 {{ user.member_code }}
            .row.no-gutters.mt-2
              .col-auto.mr-1(v-if="user.chat_status === 'pending_reply'")
                button.btn.btn-block.btn-sm.rounded-pill.btn-secondary(
                  type="button",
                  @click.stop="updateUserChatStatus(user.member_uuid, 'none')",
                  )
                    span 待回覆
                    b-icon-x
              .col-auto.mr-1(v-if="user.chat_status === 'processing_reply'")
                button.btn.btn-block.btn-sm.rounded-pill.btn-secondary(
                  type="button",
                  @click.stop="updateUserChatStatus(user.member_uuid, 'none')",
                  )
                    span 處理中
                    b-icon-x
          hr(
            style="border: 1px solid #6c757d"
          )
          .px-3.pb-3
            p.mb-0.d-block.w-100 {{ user | filterMessage }}
            small.mb-0.text-gray.d-block.w-100.text-right {{ moment(user.last_message_at.split(' ')[0]).format('YYYY/MM/DD')  }}
        infinite-loading(
          @infinite="infiniteHandler",
          :identifier="infiniteId",
          spinner="bubbles"
        )
          .cursor-default(slot="no-more") 無更多資料
          .cursor-default(slot="no-results") 無更多資料
          .cursor-default(slot="error") 發生錯誤，請重整重試一次
</template>

<script>
import { mapState } from 'vuex';
import { SA_CHAT_ROOM_INDEX } from '@/router/sa/chat-room';
import ProfilePhotoSticker from '@/components/profilePhotoSticker/ProfilePhotoStickerComponent.vue';
import InfiniteLoading from 'vue-infinite-loading';
// websocket 監聽
import Echo from 'laravel-echo';
import { BIcon, BIconX } from 'bootstrap-vue';

const moment = require('moment');
const _ = require('lodash');

export default {
  name: 'MsgManagerIndex',
  components: {
    BIcon,
    BIconX,
    ProfilePhotoSticker,
    InfiniteLoading
  },
  data() {
    return {
      infiniteId: +new Date(),
      searchInput: {
        message: "",
        unread: { label: '未讀', value: 0 },
        pending_reply: { label: '待回覆', value: 0 },
        processing_reply: { label: '處理中', value: 0 }
      }
    };
  },
  filters: {
    // 過濾最後一則訊息
    filterMessage(value) {
      // 使用者名稱
      const userName = value.display_name;
      // JSON化訊息
      let message = JSON.parse(value.message);
      // 用來放會回傳的訊息
      let returnText = '';
      // 判斷是 user 傳送或是 host 傳送
      // m2p 為 user 傳送 => '會員to顧問'
      if (value.direction === 'm2p') {
        // 判斷種類
        switch (message.type) {
          case 'text':
            returnText = message.text;
            break;
          case 'image':
            returnText = `${userName}傳送了圖片`;
            break;
          case 'video':
            returnText = `${userName}傳送了影片`;
            break;
          case 'voice':
            returnText = `${userName}傳送了語音訊息`;
            break;
          case 'sticker':
            returnText = `${userName}傳送了貼圖`;
            break;
          case 'location':
            returnText = `${userName}向您傳送了位置訊息`;
            break;
          default:
            returnText = `${userName}向您傳送了一則訊息`;
            break;
        }
        return returnText;
      }
        // 其餘都是 host 傳送
        // p2m => '顧問to會員', s2m => '系統to會員', s2p => '系統to顧問'

        // 判斷種類
        // 如果是模板，取最後一筆重組
        if (message.type === 'template') {
          message = _.last(message.data);
        }
        switch (message.type) {
          case 'text':
            if (Object.keys(message.text).length > 22) {
              returnText = `${message.text.replace(/\s+/g, '').substr(0, 22) }...`;
            } else if (Object.keys(message.text).length < 1) {
              returnText = '文字訊息已傳送';
            } else {
              returnText = message.text;
            }
            break;
          case 'image':
            returnText = '圖片已傳送';
            break;
          case 'video':
            returnText = '影片已傳送';
            break;
          case 'voice':
            returnText = '語音訊息已傳送';
            break;
          case 'sticker':
            returnText = '貼圖已傳送';
            break;
          case 'location':
            returnText = '位置訊息已傳送';
            break;
          case 'carousel':
            returnText = '橫向捲軸已傳送';
            break;
          default:
            returnText = '您傳送了一則訊息';
            break;
        }
        return returnText;
    }
  },
  created() {
    const vm = this;
    vm.$swal.fire({
      title: '載入中，請稍候',
      allowOutsideClick: false,
      willOpen: () => {
        this.$swal.showLoading();
      }
    });
    vm.$store.commit('sa_msg_manager/resetHandler');
    vm.$swal.close();
    vm.$store.commit('toggleLoading', false);
  },
  mounted() {
    const vm = this;
    // 取得個人資料, 要先去拿這個顧問的 sa_id
    vm.$store.dispatch('sa_profile/getProfileHandler')
      .then(() => {
        // todo 移到拿的到 sa_id 的地方，但是避免無限捲軸打 api 一直執行, console.log(this.sa_id) 確認
        // websocket
        window.io = require('socket.io-client');
        window.Echo = new Echo({
          broadcaster: 'socket.io',
          host: process.env.VUE_APP_WEBSOCKET_URL,
          transports: ['websocket', 'polling', 'flashsocket'],
          auth: {
            headers: {
              Authorization: window.sessionStorage.getItem('data'),
              Source: 'one-to-one'
            }
          }
        });
        console.log(window.Echo);
        // 加入 Channel
        const channelName = `one_to_one_${vm.saProfileData.id}_${process.env.VUE_APP_LINE_MESSAGE_CHANNEL_ID}`;
        window.Echo.private(channelName)
          .listen('.line.one-to-one-frontend', (e) => {
            // 收到事件 e 為收到的 data
            console.log(e);
            vm.$store.commit('sa_msg_manager/resetHandler');
            vm.infiniteId += 1;
          });
        vm.$store.dispatch('sa_item_list/getChatReadStatusHandler');
      });
  },
  methods: {
    moment(date = null) {
      return date ? moment(date) : moment();
    },
    infiniteHandler($state) {
      const vm = this;
      vm.$store.dispatch('sa_msg_manager/getChatListHandler', {
        current_page: vm.pagination.current_page + 1,
        per_page: vm.pagination.per_page,
        search_msg: vm.searchInput.message,
        show_unread_msg: vm.searchInput.unread.value,
        chat_status: Object.entries(vm.searchInput).find(([key, value]) => (key === 'pending_reply' || key === 'processing_reply') && value?.value === 1)?.[0] || '', // 預設 none, 待回覆 pending_reply, 處理中 processing_reply
      }).then(() => {
        if (vm.pagination.current_page === 0 || vm.pagination.total_page === 0) {
          $state.complete();
        }

        if (vm.pagination.current_page !== vm.pagination.total_page) {
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    },
    openMsgHandler(user) {
      const vm = this;
      const userWhitPicture = user;

      if (vm.personnelProfilePicture) {
        userWhitPicture.sa_picture = vm.personnelProfilePicture;
      }

      vm.$router.push({
        name: SA_CHAT_ROOM_INDEX,
        params: {
          chatRoomTitle: `與${user.display_name}對話`,
          user,
          sa_id: vm.sa_id
        }
      });
    },
    searchInputHandler() {
      Object.keys(this.searchInput).forEach((key) => {
        if (key !== 'message') {
          this.searchInput[key].value = 0;
        }
      });

      this.$store.commit('sa_msg_manager/resetHandler');
      this.infiniteId += 1;
    },
    searchStatusHandler(status) {
      // 目前只能單選
      Object.keys(this.searchInput).forEach((key) => {
        if (key === 'message') {
          this.searchInput.message = "";
        } else if (key === status) {
          this.searchInput[key].value = 1;
        } else {
          this.searchInput[key].value = 0;
        }
      });

      this.$store.commit('sa_msg_manager/resetHandler');
      this.infiniteId += 1;
    },
    updateUserChatStatus(member_uuid, chat_status) {
      this.$store.dispatch('sa_msg_manager/updateChatStatusHandler', { member_uuid, chat_status }).then(()=>{
        this.$store.commit('sa_msg_manager/resetHandler');
        this.infiniteId += 1;
      });
    },
  },
  computed: {
    ...mapState({
      msgList: (state) => state.sa_msg_manager.msgList,
      pagination: (state) => state.sa_msg_manager.pagination,
      personnelProfilePicture: (state) => state.sa_msg_manager.personnelProfilePicture,
      sa_id: (state) => state.sa_msg_manager.sa_id,
      saProfileData: (state) => state.sa_profile.data
    }),
    searchStatusList() {
      const isStatusActive = Object.values(this.searchInput).some((status) => status?.value === 1);

      if (isStatusActive) {
        // 選擇其中一種標籤狀態時，顯示全部
        return [{ label: '全部', name: 'all'}];
      } else {
        return Object.entries(this.searchInput)
          .filter(([key, value]) => key !== 'message')
          .map(([key, value]) => ({ label: value.label, name: key }));
      }
    }
  },
  beforeDestroy() {
    const vm = this;
    // 離開前結束 websocket 監聽事件
    window.Echo.disconnect();
    const channelName = `one_to_one_${vm.saProfileData.id}_${process.env.VUE_APP_LINE_MESSAGE_CHANNEL_ID}`;
    console.log(`Channel ${ channelName } END Listen Now`);
  }
};
</script>

<style lang="scss" scoped>
.card {
  border: 0.2rem solid #000;
  border-radius: 0.8rem;
  box-shadow: 0.2rem 0.2rem 0 #00000033;
  &-hasNews {
    &::after {
      content: "";
      position: absolute;
      right: 0.4rem;
      top: 0.4rem;
      background-color: #ef4852;
      width: 0.7rem;
      height: 0.7rem;
      border-radius: 50%;
    }
  }
}

.ProfilePhotoSticker {
  border: 0.2rem solid #000!important;
}

.message-remind::after {
  content: "";
  position: absolute;
  right: 0.5rem;
  top: 0.5rem;
  background-color: #ef4852;
  width: 0.8rem;
  height: 0.8rem;
  border-radius: 50%;
}
</style>
